import React, { useEffect, useState } from 'react'
import { ButtonSubmit, Divisor, InputDataList, Loader, SimpleAlert, TitleFormData } from './aditionalComponents'
import { requestAuth } from '../../../http/httpRequest'
import { toastOn } from '../../../store/slices/toast'
import { useDispatch } from 'react-redux'
import { Form, Formik } from 'formik'
import { ModalFormField } from '../ModalFormField'
import { CompraProductosPaso2 } from '../../../FormSchemes/CompraScheme'
import { TagsStepCompraDictionary } from '../../../utils/dictionary'

export const Step2 = ({ generalData, setMainRecall, setReload, saveUrlApi, stepNumber, stepsPermissions }) => {
  const dispatch = useDispatch()
  const [listProductosSeleccionados, setListProductosSeleccionados] = useState([])
  const [data, setData] = useState([])
  const [currentData, setCurrentData] = useState(null)
  const [loding, setLoading] = useState(true)
  const [options, setOptions] = useState([])
  const [efectivoOptions, setEfectivoOptions] = useState([])
  const [defaultValue, setDefaultValue] = useState(null)
  const [defaultEfectivo, setDefaultEfectivo] = useState(null)

  const initialValues = {
    almacen_proveedor_id: generalData?.almacen_proveedor_id || '',
    productos: listProductosSeleccionados,
    monto_compra: currentData?.monto_compra ? (currentData?.monto_compra < 0 ? currentData?.monto_compra * -1 : currentData?.monto_compra) : 0,
    monto_flete: currentData?.monto_flete ? (currentData?.monto_flete < 0 ? currentData?.monto_flete * -1 : currentData?.monto_flete) : 0,
    monto_otros: currentData?.monto_otros ? (currentData?.monto_otros < 0 ? currentData?.monto_otros * -1 : currentData?.monto_otros) : 0,
    efectivo_id: generalData?.efectivo_id ?? '',
    obs_confirmacion_compra: currentData?.obs_confirmacion_compra ?? '',
  };

  const getData = async () => {
    await requestAuth(
      'get',
      `compra/${generalData?.id}/fullDetail`,
      null
    )
      .then((response) => {
        setListProductosSeleccionados(response.data.solicitadosMap)
        setCurrentData(response.data)
        setData(response.data.solicitadosMap.map(s => ({ 'compra_historial_id': s.id + '', 'cantidad': s.cantidad })))
        setLoading(false)
        const opt = response.data?.almacenProveedoresMap?.map(item => ({
          value: item['id'] ?? item.id.toString(),
          label: item['nombre']
        }))
        if (response?.data?.almacen_proveedor_id)
          setDefaultValue({ value: response?.data?.almacen_proveedor_id, label: response?.data?.almacen_proveedor_nombre })
        setOptions(opt)
        const optE = response.data?.efectivosMap?.map(item => ({
          value: item['id'] ?? item.id.toString(),
          label: item['etiqueta']
        }))
        if (response?.data?.efectivo_id)
          setDefaultEfectivo({ value: response?.data?.efectivo_id, label: response?.data?.efectivosMap?.find(e => e.id === response?.data?.efectivo_id)?.etiqueta })
        setEfectivoOptions(optE)
      }
      )
      .catch(error => {
        dispatch(toastOn({ type: 'danger', message: error?.response?.data?.message || 'error a listar las casillas.' }))
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const addData = (value, name) => {
    const newData = data.map(item => {
      if (item.compra_historial_id === name) {
        return { ...item, cantidad: parseFloat(value) };
      }
      return item;
    })
    setData(newData)
  }
  const onSubmit = async (values) => {
    await requestAuth(
      'put',
      saveUrlApi,
      values
    )
      .then((response) => {
        dispatch(toastOn({ type: 'success', message: response.data.message }))
        setMainRecall(a => !a)
        setReload()
      }
      )
      .catch(error => {
        dispatch(toastOn({ type: 'danger', message: error?.response?.data?.message ?? 'Error al enviar el formulario!' }))
      })
  }
  return (
    <>
      <TitleFormData
        title={TagsStepCompraDictionary[stepNumber]}
        subtitle={currentData?.fecha_confirmacion_compra}
      />
      {
        loding ?
          <Loader />
          :
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({ errors, isSubmitting, touched, values, submitForm, handleChange, setFieldValue }) => (
              <>

                <InputDataList
                  list={listProductosSeleccionados}
                  addData={addData}
                  field={{ indexLabel: 'etiqueta', indexId: 'id', indexRight: 'cantidadAlmacen' }}
                  setFieldValue={setFieldValue}
                  setDataList={setListProductosSeleccionados}
                />
                <Divisor />
                <Form className='col-span-12 grid grid-cols-12 rounded-lg gap-3'>
                  <ModalFormField
                    fields={CompraProductosPaso2(options, defaultValue, efectivoOptions, defaultEfectivo)?.fields}
                    errors={errors}
                    touched={touched}
                    values={values}
                    setValues={setFieldValue}
                    handleChange={handleChange}
                    calculators={CompraProductosPaso2()?.calculators}
                    submitForm={submitForm}
                  />
                  {
                    values.efectivo_id != null && values.efectivo_id !== '' &&
                    <SimpleAlert
                      data={<>Se creará un movimiento en egreso en <span className='font-semibold'>{currentData?.efectivosMap?.find(e => e.id === values.efectivo_id)?.etiqueta}</span>.</>}
                    />
                  }
                  <div className='col-span-12 text-right mt-3'>
                    <ButtonSubmit
                      isSubmitting={isSubmitting}
                      disabled={generalData?.paso === stepNumber && stepsPermissions?.buttonsActive?.includes(2) ? false : true}
                      textButton='Siguiente'
                    />
                  </div>
                </Form>
              </>
            )}
          </Formik>
      }
    </>
  )
}